/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ResumeCampaignMutationResponse,
  ResumeCampaignPathParams,
  ResumeCampaign400,
} from '../types/ResumeCampaign'

function getResumeCampaignUrl({
  bison_campaign_id,
}: {
  bison_campaign_id: ResumeCampaignPathParams['bison_campaign_id']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/emailbison/campaigns/${bison_campaign_id}/resume/` as const,
  }
  return res
}

/**
 * @description Launch/resume a campaign.
 * This starts a paused or draft campaign so it begins sending emails.
 * @summary Resume a paused campaign
 * {@link /api/v1/emailbison/campaigns/:bison_campaign_id/resume/}
 */
export async function resumeCampaign(
  {
    bison_campaign_id,
  }: { bison_campaign_id: ResumeCampaignPathParams['bison_campaign_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ResumeCampaignMutationResponse,
    ResponseErrorConfig<ResumeCampaign400>,
    unknown
  >({
    method: 'POST',
    url: getResumeCampaignUrl({ bison_campaign_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
